import { useTranslation } from 'react-i18next';

export const useGetConceptDescriptionSteps = () => {
    const { t } = useTranslation();
    return [
        {
            step: t('aboutUs.conceptDescription.uniqueCostumes'),
        },
        {
            step: t('aboutUs.conceptDescription.themedDances'),
        },
        {
            step: t('aboutUs.conceptDescription.showFeatures'),
        },
    ];
};

export const useGetDefiningFeatureSteps = () => {
    const { t } = useTranslation();
    return [
        {
            step: t(
                'aboutUs.conceptDescription.theDefiningFeatures.highLevelExecutionOfChoreography'
            ),
        },
        {
            step: t(
                'aboutUs.conceptDescription.theDefiningFeatures.professionalApproach'
            ),
        },
        {
            step: t(
                'aboutUs.conceptDescription.theDefiningFeatures.allCostumesAreDesigned'
            ),
        },
    ];
};
